/*jslint browser */
/*global process */

import Product from "../../entity/product";

var $ = jQuery;

/**
 *
 */
export default class Cart
{
    private _selectAccessory: JQuery;
    private _productList: Array<Product>;
    private _priceSummary: number = 0;
    private _variationsForm: JQuery;
    private _variationsData: any;
    private _variationsPrices: any = {};
    private _variationProduct: boolean = false;
    private _variationId: number;
    private _variationIdInput: JQuery;
    private _productPrice: number = 0;
    private _currentProductPrice: number = 0;
    private _productAccessories: JQuery;
    private _qty: JQuery;
    private _productId: number;
    private _addToStorage : JQuery;
    private _productAdditionalPrice : JQuery;

    public init(): void {
        this._selectAccessory = $('.select-accessory');
        this._variationsForm = $('.variations_form');
        this._productAccessories = $('#product_accessories');
        this._productAdditionalPrice = $('#product_additional_price');
        this._addToStorage = $('.add-to-storage');
        this._qty = $('.qty');
        if(this._variationsForm && this._variationsForm.is(':visible')) {
            this._variationProduct = true;
            this._variationIdInput = $('.variation_id');
            this.setVariationPrices();
            this.setVariationId();
        }

        this.update();
    }

    public update(): void {
        this.emptyCart();
        this.collectData();
        if(this.isProductVariation()) {
            this.setVariationId();
        }
        this.updatePrice();
        this.addAccessoriesToCart();
    }

    public getPrice(): number {
        return this._priceSummary;
    }

    public emptyCart(): void {
        this._productList = [];
        this._priceSummary = 0;
        this._variationId = 0;
        this.clearAccessories();
        this.emptyStorage();
    }

    public isProductVariation(): boolean {
        return this._variationProduct;
    }

    public setProductPrice(price: number) {
        this._productPrice = price;
    }

    public setMainProductId(id: number) {
        this._productId = id;
    }

    public getCurrentProductPrice(): number {
        return this._currentProductPrice;
    }

    private setVariationPrices() {
        this._variationsData = this._variationsForm.data('product_variations');
        for (const [key, variationData] of Object.entries(this._variationsData)) {
            const variation: any = variationData;
            this._variationsPrices[variation.variation_id] = variation.display_price;
        }
    }

    private setVariationId(): void {
        this._variationId = this._variationIdInput.val() as unknown as number;
    }

    private collectData(): void {
        const thisObject = this;
        this._selectAccessory.each(function() {
            if($(this).is(':checked')) {
                thisObject.addProduct($(this));
            }
        })
    }

    private addProduct(ob: JQuery): void {
        const product = new Product();
        product.id = ob.data('id') as unknown as number;
        product.name = ob.data('name');
        product.price  = ob.data('price') as unknown as number;
        product.quantity = 1; //quantity of single product, in case od sets change
        product.parent = this._productId;

        this._productList.push(product);
        this.addAccessoryToStorageList(product.id);
    }

    private updatePrice() {
        let price = 0;
        const quantity = this._qty.val() as number;
        for (const [key, product] of Object.entries(this._productList)) {
            price += product.price * product.quantity;
        }

        if(this.isProductVariation()) {
            if(this._variationsPrices.hasOwnProperty(this._variationId)) {
                this._currentProductPrice = this._variationsPrices[this._variationId];
                price += this._variationsPrices[this._variationId];
            }
        } else {
            this._currentProductPrice = this._productPrice;
            price += this._productPrice;
        }

        const additionalPrice = this._productAdditionalPrice.val() as unknown as number;
        // @ts-ignore
        price = price + parseFloat(additionalPrice);

        price = price * quantity;

        this._priceSummary = price;
    }

    private addAccessoriesToCart(): void {
        const serializedData = JSON.stringify(this._productList);
        this._productAccessories.val(serializedData);
    }

    private clearAccessories(): void {
        this._productAccessories.val('');
    }

    private emptyStorage(): void {
        this._addToStorage.attr( "data-accessory", '');
    }

    private addAccessoryToStorageList(product: number): void {
        let object: any = [];
        const storage = this._addToStorage.attr('data-accessory');
        if(storage) {
            object = JSON.parse(storage);
        }
        object.push(product);
        const json = JSON.stringify(object);
        this._addToStorage.attr( "data-accessory", json );
    }
}